import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center justify-between px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
            31
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              31黑料网
            </span>
            <span className="hidden text-[11px] font-medium tracking-[0.2em] text-secondary-500 sm:block">
              黑料排行 · 专题合集
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3.5 py-2 md:flex">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-500" />
            </span>
            <input
              type="text"
              placeholder="搜索黑料关键词"
              className="w-36 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:block"
          >
            订阅热度提醒
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="打开导航菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200/80 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              订阅热度提醒
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}